import { Component, signal, inject } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { ConfirmationModalComponent } from './shared/components/confirmation-modal/confirmation-modal.component';
import { SessionModalComponent } from './shared/components/session-modal/session-modal.component';
import { SessionService } from './core/services/session.service';
import { AuthService } from './core/services/auth.service';
import { TranslationExtenderService } from './core/services/translation-extender.service';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet, ConfirmationModalComponent, SessionModalComponent],
  templateUrl: './app.html',
  styleUrl: './app.css'
})
export class App {
  protected readonly title = signal('gaul-bridge-frontend');
  private sessionService = inject(SessionService);
  private authService = inject(AuthService);
  private translationExtender = inject(TranslationExtenderService);

  constructor(private translate: TranslateService) {
    this.translate.addLangs(['en', 'es', 'fr']);
    this.translate.setDefaultLang('en');
    const savedLang = localStorage.getItem('lang') || 'en';
    this.translate.use(savedLang);

    if (this.authService.isAuthenticated()) {
      // Warm CSRF in background — guard reuses this promise instead of making a second request
      this.authService.ensureCsrfReady();
      // Kickstart remaining translation modules in parallel with CSRF and initial 3 files.
      // By the time the auth guard awaits translationExtender.load(), it's already in-flight
      // and the await costs near zero (shareReplay delivers the cached result instantly).
      this.translationExtender.load(savedLang).subscribe();
    }
  }
}
